module.exports = __webpack_public_path__ + "img/alcohol.f1b9d6fc.svg";